import { useLocation } from 'react-router-dom';
import { canonicalPathForLocation } from '../utils/canonicalUrls.js';

const PREVIEW_KEYS = ['embed', 'editor', 'lockNavigation', 'preview', 'previewTier'];
const UNPUBLISHED = new Set(['DRAFT', 'SCHEDULED', 'PENDING', 'PENDING_REVIEW', 'REJECTED', 'UNPUBLISHED', 'INACTIVE', 'DELETED', 'SUBMITTED', 'NEEDS_CHANGES', 'PAUSED']);

export function publicShareData({ contentType, title, metadata, hidden = false, status, publicationStatus }, search = '') {
  const params = new URLSearchParams(search);
  if (hidden || PREVIEW_KEYS.some((key) => params.has(key)) || UNPUBLISHED.has(String(status || '').toUpperCase()) || (publicationStatus != null && String(publicationStatus).toUpperCase() !== 'PUBLISHED') || !(metadata?.canonicalUrl || metadata?.publicShareUrl)) return undefined;
  let url;
  try { url = new URL(metadata.canonicalUrl || metadata.publicShareUrl); } catch { return undefined; }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return undefined;
  const path = canonicalPathForLocation(url.pathname, url.search);
  url.search = path.includes('?') ? path.slice(path.indexOf('?')) : '';
  url.hash = '';
  return { contentType, title, description: metadata.description, image: metadata.openGraph?.imageUrl, canonicalUrl: url.href };
}

export function usePublicShareData(input) {
  const { search } = useLocation();
  return publicShareData(input, search);
}
